import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
    div: {
        paddingLeft: 16,
    },
}));
